<section class="page-wrapper gallery cf">
  <div class="latest-detail-section latest-video-page">
     <div class="container">
        <div class="latest-news cf" id="videos">
           <h2 class="latest-Videos-titel ">Gallery </h2>
           <div class="latest-video  album cf">
              <div class="latest-news-box" *ngFor="let group of groupList">
                 <div class="latest-news-hover" [ngStyle]="{'background-image':'url(' + group?.image + ')'}">
                 </div>
                 <a [routerLink]="['/albums', group?.slug]">
                    <div class="news-box-overlay"></div>
                 </a>
                 <div class="latest-news-content">
                    <h4>{{group?.title}}</h4>
                    <span>{{group?.created_at | amDateFormat:'DD-MM-YYYY'}}</span>
                    <!-- <div class="news-share-box-icon">
                       <ul class="news-share-icon">
                          <li>
                             <a href="javascript:void(0);">
                             <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                             </a>
                          </li>
                       </ul>
                       <ul class="news-social-icon">
                          <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                          <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                          <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                       </ul>
                    </div> -->
                 </div>
              </div>
              <!-- <div class="latest-news-box" >
                 <div class="latest-news-hover" Style="background-image:url(assets/images/clubsponsor-img.jpg)">
                 </div>
                 <a routerLink="/">
                    <div class="news-box-overlay"></div>
                 </a>
                 <div class="latest-news-content">
                    <h4>Coming at you</h4>
                    <span>12-09-2021</span>
                    <div class="news-share-box-icon">
                       <ul class="news-share-icon">
                          <li>
                             <a href="javascript:void(0);">
                             <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                             </a>
                          </li>
                       </ul>
                       <ul class="news-social-icon">
                          <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                          <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                          <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                       </ul>
                    </div>
                 </div>
              </div>
              <div class="latest-news-box" >
                 <div class="latest-news-hover" Style="background-image:url(assets/images/clubsponsor-img.jpg)">
                 </div>
                 <a routerLink="/">
                    <div class="news-box-overlay"></div>
                 </a>
                 <div class="latest-news-content">
                    <h4>Coming at you</h4>
                    <span>12-09-2021</span>
                    <div class="news-share-box-icon">
                       <ul class="news-share-icon">
                          <li>
                             <a href="javascript:void(0);">
                             <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                             </a>
                          </li>
                       </ul>
                       <ul class="news-social-icon">
                          <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                          <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                          <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                       </ul>
                    </div>
                 </div>
              </div>
              <div class="latest-news-box" >
                 <div class="latest-news-hover" Style="background-image:url(assets/images/clubsponsor-img.jpg)">
                 </div>
                 <a routerLink="/">
                    <div class="news-box-overlay"></div>
                 </a>
                 <div class="latest-news-content">
                    <h4>Coming at you</h4>
                    <span>12-09-2021</span>
                    <div class="news-share-box-icon">
                       <ul class="news-share-icon">
                          <li>
                             <a href="javascript:void(0);">
                             <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                             </a>
                          </li>
                       </ul>
                       <ul class="news-social-icon">
                          <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                          <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                          <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                       </ul>
                    </div>
                 </div>
              </div>
              <div class="latest-news-box" >
                 <div class="latest-news-hover" Style="background-image:url(assets/images/clubsponsor-img.jpg)">
                 </div>
                 <a routerLink="/">
                    <div class="news-box-overlay"></div>
                 </a>
                 <div class="latest-news-content">
                    <h4>Coming at you</h4>
                    <span>12-09-2021</span>
                    <div class="news-share-box-icon">
                       <ul class="news-share-icon">
                          <li>
                             <a href="javascript:void(0);">
                             <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                             </a>
                          </li>
                       </ul>
                       <ul class="news-social-icon">
                          <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                          <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                          <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                       </ul>
                    </div>
                 </div>
              </div> -->
           </div>
           <div class="load-more" *ngIf="!groupList_last_page" >
              <button  (click)="getMoregroup()" class="btn-loadmore ">Load More</button>
           </div>
        </div>
     </div>
  </div>
</section>